/**
 * TEMPORARY initial-data setup tool.
 *
 * Flip this to false (or delete this file, the page, the api module, the route and the sidebar
 * entry) once the final website data has been loaded. The backend counterpart is the
 * `mn.stusolution.sfg.setupimport` package.
 */
export const SETUP_IMPORT_ENABLED = true;
